<!--
 * @Author: hujie striveyf@dingtalk.com
 * @Date: 2023-09-21 08:55:35
 * @LastEditors: hujie striveyf@dingtalk.com
 * @LastEditTime: 2023-11-17 10:27:14
 * @FilePath: \distribution_webf:\JOB\distribution-h5\src\views\phoneOrderTwo\index.vue
 * @Description: 新版选号
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
-->
<template>
  <div class="place-an-order">
    <div class="banner" style="font-size: 0px" ref="wrappers" v-if="!componentBoolean">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" v-if="orderData && orderData.infoImageUrls">
        <van-swipe-item
          v-for="(item, index) in orderData.infoImageUrls"
          :key="index"
        >
          <picture>
            <source type="image/webp" :srcset="item.imageUrlWebp" class="place-bottom-img"/>
            <img :src="item.imageUrl" alt="" class="place-bottom-img"/>
          </picture>
          <!-- <img :src="item" alt="" class="place-bottom-img" :key="index" /> -->
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- :style="{ backgroundColor: orderData? orderData.formColour: 'red'}" -->
    <div
      class="order-wrapper"
      :style="{ backgroundColor: orderData ? orderData.formColour : '' }"
      id="btn"
    >
      <div class="content-top">
        <van-field
          class="input"
          readonly
          clickable
          clearable
          clear-trigger="always"
          name="area"
          :value="value"
          placeholder="归属地（可选）"
          @click="showArea = true"
          label="归属地（可选）"
          v-if="!NingXiaProduct.isSearchWwrap"
        >
          <div slot="right-icon" class="area-button-box">
            <van-icon
              @click.stop="clearValue"
              v-show="value !== ''"
              class="area-button-clear"
              name="close"
            />
          </div>
        </van-field>
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            @confirm="onConfirm"
            @cancel="showArea = false"
          />
        </van-popup>
        <van-field
          class="input"
          readonly
          clickable
          clearable
          clear-trigger="always"
          name="checkNo"
          :value="checkNo"
          placeholder="已选号码"
          label="已选号码"
        >
        </van-field>
      </div>
      <div class="content-type">
        <div v-for="(item, index) in typeList" :key="index"
          class="typeLi" :class="item.checkType? 'typeLicheck': ''"
          @click="selectCheckLi(index)">
          {{ item.name }}
        </div>
      </div>
      <!-- 号码 -->
      <div class="content-list">
        <ul class="warpper">
          <li
            v-for="(item, index) in numberList"
            :key="index"
            class="listContent"
            @click="selectNumber(item)"
          >
            <p class="phoneNumber">{{ item }}</p>
            <p class="tag">免费领取</p>
          </li>
        </ul>
        <div class="pagination" v-if="orderData && orderData.thirdPartyProductType !== 12 && orderData.thirdPartyProductType !== 13">
          <div @click="prePage" class="active"
            :class="this.currentNumberListPage <= 1? 'noMore': 'more'">上一页</div>
          <div @click="nextPage" class="next active"
            :class="(this.currentNumberListPage + 1) * 8 >= this.numberListTotal? 'noMore': 'more'">
            下一页
          </div>
        </div>
        <div class="pagination" v-else>
          <!-- loading -->
          <van-loading
            color="#1989fa"
            v-if="loadingshow"
          />
          <div @click="prePage" class="active more" v-else>换一批</div>
        </div>
      </div>
    </div>
    <!-- 底部图片 -->
    <div
      style="font-size: 0px"
      v-if="
        orderData && orderData.detailDrawingImgUrls && orderData.detailDrawingImgUrls.length
      "
    >
      <!-- <img
        :src="item"
        alt=""
        class="place-bottom-img"
        v-for="(item, index) in orderData.detailDrawingImgUrls"
        :key="index"
      /> -->
      <picture v-for="(item, index) in orderData.detailDrawingImgUrls" :key="index">
        <source type="image/webp" :srcset="item.imageUrlWebp" class="place-bottom-img"/>
        <img :src="item.imageUrl" alt="" class="place-bottom-img"/>
      </picture>
    </div>
    <!-- 购买popup -->
    <payPopup
      ref="payPopup"
      :orderData="orderData"
      :areaList="areaList"
      :productId="orderData? orderData.productId: null"
      :jsTransform="jsTransform"
      :failJumpTreeFlag="failJumpTreeFlag"
      :judgmentOrder="judgmentOrder"
      @handleJudgmentOrder="handleJudgmentOrder"
    />
    <ul class="homeAction" v-if="actionData.length > 0">
      <li class="homeActionItem" v-if="actionData.includes('1')" @click="goLink('report')">
        <img src="../../assets/homeTS.png" alt="" class="homeActionIcon">
        投诉反馈
      </li>
      <li class="homeActionItem" v-if="actionData.includes('2')" @click="goLink('order')">
        <img src="../../assets/homeDD.png" alt="" class="homeActionIcon">
        我的订单
      </li>
      <li class="homeActionItem" v-if="actionData.includes('3')" @click="goKf()">
        <img src="../../assets/homeKF.png" alt="" class="homeActionIcon">
        联系客服
      </li>
    </ul>
  </div>
</template>

<script>
  import {
    getWebPage,
    getLocation,
    getPhoneNumber,
    getWebPageAllInfo,
    apiGetTransitFlag,
    getNumber2,
    postCongmaoCardNumber,
    postMenglong172NumberList,
  } from "@/api/api";
  import { typeList, getAddress } from '@/common/js/config'
  import payPopup from './modules/payPopup.vue'
  //监听浏览器关闭事件
  const obj = {
    failJumpTreeFlag: false,  //判断是否跳转
    judgmentOrder: false   //判断是否下单
  };
  // 定义一个obj变量监听器
  const handler = {
    set(target, key, value) {
      target[key] = value;
      return true;
    },
  };
  // 创建一个Proxy对象来监听obj变量的变化
  const proxyObj = new Proxy(obj, handler);

  //监听离开或关闭页面的方法
  // document.addEventListener('backbutton', function (e) {
  //   if(obj.failJumpTreeFlag && !obj.judgmentOrder){
  //     window.history.back()
  //     skipInfo("home_leave")
  //   }
  // }, false);
  window.addEventListener("popstate", function (e) {
    if(obj.failJumpTreeFlag && !obj.judgmentOrder){
      window.history.back()
      skipInfo("home_leave")
    }
  }, false);
  //改方法添加了一个历史记录，路径为#，保证了不刷新页面，不直接后退。
  function pushHistory() {
    var state = {
      title: "title",
      url: "#"
    };
    window.history.pushState(state, "title", "#");
  }
  //添加跳转信息函数
  function skipInfo(pointNum){
    // 初始化sdk
    let time = new Date().getTime()
    let random = Math.floor(Math.random() * (999999 - 1 + 1) + 1); // 生成范围在[1, 999999]内的随机整数
    let sessionId = time + '' + random;
    const sdk = recsdk.init({
      "sessionId": sessionId,
      "unionKey": "d465bad1c3254033aaf46fe37d875047",
    })
    // 调用获取推荐产品，获取成功后自动跳转连接
    sdk.getAd({
        isp: "ISP-CMCC",
        phoneNum: "",
        phoneProvince: "",
        ErrCode: "",
        errMsg: "",
        Media: "",
        pointNum,
    }, err => {
        // 获取失败的回调 - 可自行处理错误流程
        console.log('err==>', err)
    })
  }
  export default {
    name: 'newPhoneOrder',
    props: {
      componentBoolean: {
        type: Boolean,
        default() {
          return false
        }
      },
      productId: {
        type: String || Number,
        default() {
          return null
        }
      }
    },
    data () {
      return {
        orderData: null,
        showArea: false,
        value: "", //地区
        areaList: {}, //城市列表数据
        cityCode: null,
        belongProvince: null,
        belongCity: null,
        loadingshow: false,
        selectPhoneId: null,
        checkNo: null, //已选号码
        typeList,
        numberList: null,
        currentNumberListPage: 1,
        numberListTotal: 0,
        transitionType: 0,
        transitionJsFlag: false,
        transitionOpportune: -1,
        transitionCode: "",
        NingXiaProduct: {
          isSearchWwrap: false,
        } /* 宁夏产品 */,
        judgmentOrder: obj.judgmentOrder,
        failJumpTreeFlag: proxyObj.failJumpTreeFlag,
        actionData: [],
        hkProductId: "", // 梦龙172产品ID
        menglong172NumberList: [], // 梦龙172号码列表
      }
    },
    created () {
      this._getData(this.$route.params);
      this.pageId = this.$route.params.id;
      this.$store.commit("setPathName", window.location.pathname);
      this.numberAllList = [];
      this.numberListTotal = [];
      this.numberList = [];
      this.value = "";
      this.belongCity = "";
      this.belongProvince = "";
      this.checkNo = null;
    },
    watch: {
      currentNumberListPage: function (val) {
        this.numberList = this.numberAllList.slice(val * 8, (val + 1) * 8);
      },
    },
    methods: {
      goLink(type) {
        let url = new Map([
          ['order', '/order'],
          ['report', '/report']
        ])
        this.$router.push({
          path: url.get(type),
        })
      },
      //下单弹窗传来判断是否下单失败
      handleJudgmentOrder(data){
        proxyObj.judgmentOrder = data;
        this.judgmentOrder = data;
      },
      prePage() {
        if(this.loadingshow) return
        if (this.orderData.thirdPartyProductType === 12) {
          this.searchNumber3();
          return
        } else if(this.orderData.thirdPartyProductType === 13){ // 梦龙172
          this.menglong172Number();
          return
        }
        if (this.currentNumberListPage <= 1) {
          this.$toast("到头了");
          return;
        }
        --this.currentNumberListPage;
      },
      nextPage() {
        if (this.orderData.thirdPartyProductType === 12) {
          this.searchNumber3();
          return
        }
        if ((this.currentNumberListPage + 1) * 8 >= this.numberListTotal) {
          this.$toast("没有更多了");
          return;
        }
        ++this.currentNumberListPage;
      },
      selectNumber (argument) {
        this.checkNo = argument;
        const params = {
          number: argument,
          numberId: '',
          numberPoolId: '',
        }
        this.menglong172NumberList.forEach(item => {
          if(item.number === argument){
            params.numberId = item.numberId;
            params.numberPoolId = item.numberPoolId;
          }
        })
        this.$refs.payPopup.show(params)
      },
      clearValue() {
        this.value = "";
        this.belongCity = "";
        this.belongProvince = "";
        this.searchNumberAll();
      },
      onConfirm(values) {
        this.cityCode = values[values.length - 1].code;
        this.belongProvince = values[0].code;
        this.belongCity = values[1].code;
        this.value = values
          .filter((item) => !!item)
          .map((item) => item.name)
          .join("/");
        this.searchNumberAll();
        this.showArea = false;
        // this.select_pla = values;
      },

      _getData({ id }) {
        this.$store.commit("setClickId", window.location.href);
        getLocation().then((res) => {
          console.log(res);
          //定义获取地址
          this.areaList = getAddress(res);
        });
        let getWebPageApi
        this.componentBoolean? getWebPageApi = getWebPageAllInfo: getWebPageApi = getWebPage
        let params
        this.componentBoolean? params = {
          id,
          productCode: this.productId
        }: params = {
          id,
        }
        this.loadingshow = true
        getWebPageApi(params).then((res) => {
          if (res && res.code === 200) {
            if(res.result.webPageAllInfoVO.failJumpTreeFlag === null){
              proxyObj.failJumpTreeFlag = false;
            } else {
              proxyObj.failJumpTreeFlag = res.result.webPageAllInfoVO.failJumpTreeFlag;
            }
            if(obj.failJumpTreeFlag){
              //引入SDK的script
              let scriptElement = document.createElement('script');
              // 如果字段的值等于指定的值，则引入src
              scriptElement.src = 'https://staticcdntx.xwtec.cn/static/taobaoH5/busi/fs/js/sdk/rec_00ad8c2295.min.js';
              document.body.appendChild(scriptElement);
            }
            if(obj.failJumpTreeFlag && !obj.judgmentOrder){
              pushHistory()
            }
            this.orderData = res.result.webPageAllInfoVO;
            this.$emit('ok', this.orderData);
            if (res.result.webPageAllInfoVO.thirdPartyProductType === 12) {
              this.searchNumber3()
              this.NingXiaProduct.isSearchWwrap = false
            } else if(res.result.webPageAllInfoVO.thirdPartyProductType === 13){
              this.hkProductId = res.result.webPageAllInfoVO.hkProductId;
            } else {
              this.NingXiaProduct.isSearchWwrap =
                  res.result.webPageAllInfoVO.choosePhoneNum;
            }

            if (res.result.webPageAllInfoVO.choosePhoneNum) {
              this.selectPhoneId = res.result.webPageAllInfoVO.productId;
              this.searchNumber()
            }
            console.log(res.result.webPageAllInfoVO);
            this.transitionType = res.result.webPageAllInfoVO.transitionType;
            if (this.transitionType === 1)
              eval(res.result.webPageAllInfoVO.headCode);
            this.transitionOpportune =
              res.result.webPageAllInfoVO.transitionOpportune;
            this.transitionJsFlag = res.result.webPageAllInfoVO.transitionJsFlag;
            this.transitionCode = res.result.webPageAllInfoVO.transitionCode;
            this.actionData = res.result.webPageAllInfoVO.imgSideFeatures;
            this.jsTransform(1);
          } else {
            this.$router.push("/404");
          }
        }).finally(() => {
          this.loadingshow = false
        })
      },
      searchNumber () {
        console.log('searchNumber');
        getPhoneNumber(this.selectPhoneId).then(
          (res) => {
            if (res && res.code === 200) {
              this.numberAllList = res.result;
              this.numberListTotal = res.result.length;
              this.numberList = this.numberAllList.slice(0, 8);
            } else {
              this.numberAllList = [];
              this.numberListTotal = 0;
              this.numberList = [];
            }
          }
        );
      },
      searchNumber3 () {
        // 从茂
        let params = {
          addressProvince: this.value.split('/')[0],
          addressCity: this.value.split('/')[1],
          searchValue: ''
        }
        this.loadingshow = true;
        postCongmaoCardNumber(params).then(
            (res) => {
              if (res && res.code === 200) {
                this.numberAllList = res.result.map((item) => item.number);
                this.numberListTotal = res.result.length;
                this.numberList = this.numberAllList.slice(0, 8);
              } else {
                this.numberAllList = [];
                this.numberListTotal = 0;
                this.numberList = [];
              }
            }
        ).finally(() => {
          this.loadingshow = false;
        });
      },
      searchNumber2() {
        console.log('searchNumber2');
        this.loadingshow = true;
        console.log(this.value);
        const params = {
          currentPage: this.currentNumberListPage,
          pageSize: 30,
          regionId: Number(this.belongCity),
          fuzzyTag: 0,
        };
        getNumber2(params).then((res) => {
          if (res && res.code === 200) {
            this.numberAllList = res.result.numList.map((item) => item.accessNum);
            this.numberListTotal = res.result.numList.map(
              (item) => item.accessNum
            ).length;
            this.numberList = this.numberAllList.slice(0, 8);
            this.loadingshow = false;
          } else {
            this.numberAllList = [];
            this.numberListTotal = 0;
            this.numberList = [];
          }
        }).finally(() => {
          this.loadingshow = false;
        })
        // const params_taocan = {
        //   provinceCode: Number(this.belongProvince),
        // };
        // getTaoCan(params_taocan).then((res) => {
        //   this.taocanList = res.result;
        //   this.taocanListlength = res.result.length;
        //   this.tcgoods = res.result.map((item) => item.goodsName);
        //   this.goodsChildList = this.taocanList.map(
        //     (item) => item.goodsChildList
        //   );
        // });
      },
      // 梦龙172产品号码
      menglong172Number(){
        if(!this.value){
          this.$toast("请选择归属地");
          return
        }
        let params = {
          productId: this.hkProductId,
          addressProvince: this.value.split('/')[0],
          addressCity: this.value.split('/')[1],
          searchValue: ''
        }
        this.loadingshow = true;
        postMenglong172NumberList(params).then(
            (res) => {
              if (res && res.code === 200) {
                this.menglong172NumberList = res.result;
                this.numberAllList = res.result.map((item) => item.number);
                this.numberListTotal = res.result.length;
                this.numberList = this.numberAllList.slice(0, 8);
              } else {
                this.numberAllList = [];
                this.numberListTotal = 0;
                this.numberList = [];
              }
            }
        ).finally(() => {
          this.loadingshow = false;
        });
      },
      selectCheckLi (argument) {
        this.typeList.map((item, index) => {
          if (argument === index) {
            item.checkType = true
          } else {
            item.checkType = false
          }
        })
        if(this.orderData && this.orderData.thirdPartyProductType === 13){
          this.menglong172Number();
          return
        }
        this.searchNumberAll();
        return;
        if (argument === 0) {
          this.searchNumberAll();
        } else {
          this.numberAllList = [];
          this.numberListTotal = [];
          this.numberList = [];
          this.$toast("暂无此类型号码");
        }
      },
      searchNumberAll () {
        if (this.NingXiaProduct.isSearchWwrap) {
          this.searchNumber();
        } else if (this.orderData && this.orderData.thirdPartyProductType === 12) {
          this.searchNumber3();
        } else if(this.orderData && this.orderData.thirdPartyProductType === 13){
          this.menglong172Number();
        } else {
          this.searchNumber2();
        }
      },
      jsTransform(opportunity) {
        if (
          this?.transitionType !== 1 ||
          !this?.transitionJsFlag ||
          this?.transitionOpportune !== opportunity
        )
          return Promise.resolve();
        if (this.transitionOpportune === 1) {
          eval(this.transitionCode);
          return Promise.resolve();
        }
        if (this.transitionOpportune === 2) {
          return apiGetTransitFlag(this.pageId).then((res) => {
            if (res.code === 200 && res.result) {
              // 转换代码
              eval(this.transitionCode);
              return Promise.resolve();
            }
          });
        }
      },
      goKf() {
        window.location.href = this.orderData.kefuUrl;
      },
    },
    components: {
      payPopup
    }
  }
</script>

<style lang="less" scoped>
  .place-an-order {
    min-height: 100%;
    position: relative;
    .homeAction {
      position: fixed;
      right: 0;
      top: 40px;
      .homeActionItem {
        background-color: #000000;
        border-radius: 32px 0 0 32px;
        opacity: 0.8;
        margin-bottom: 15px;
        font-size: 16px;
        color: #fff;
        padding: 6px 10px;
        display: flex;
        align-items: center;
        .homeActionIcon {
          width: 18px;
          height: 18px;
          padding-right: 4px;
        }
      }
    }
    .place-bottom-img {
      width: 100%;
      height: 100%;
    }
    .order-wrapper {
      padding: 15px;
      .content-top {
        background-color: #F5F5F5;
        border-radius: 5px;
      }
      .content-list, .content-type {
        background-color: #F5F5F5;
      }
      .content-list {
        padding: 0px 15px;
        .pagination {
          display: flex;
          justify-content: center;
          padding: 15px 0;
          .active {
            flex: 40%;
            border-radius: 17px;
            font-size: 15px;
            line-height: 34px;
          }
          .more {
            background-color: #F3293C;
            color: #fff;
          }
          .noMore {
            background-color: #EBEBEB;
            color: #999;
          }
          .active:nth-child(odd) {
            margin-right: 10px;
          }
        }
        .warpper {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .listContent {
            flex: 42%;
            background-color: #fff;
            margin-bottom: 10px;
            padding: 15px 10px;
            box-sizing: border-box;
            text-align: left;
            border-radius: 5px;
            .phoneNumber {
              color: #333333;
              font-size: 17px;
              font-weight: bold;
            }
            .tag {
              color: #666;
              font-size: 13px;
              font-weight: 500;
            }
          }
          .listContent:nth-child(odd) {
            margin-right: 10px;
          }
        }
      }
      .content-type {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 15px;
        .typeLi {
          flex: 23%;
          background-color: #ccc;
          border-radius: 15px;
          font-size: 14px;
          color: #fff;
          line-height: 29px;
          margin: 3px;
        }
        .typeLicheck {
          background-color: #F3293C;
        }
      }
    }
    /deep/ .van-field__label  {
      width: 7.2em !important;
    }
  }
</style>
